import React, { BaseSyntheticEvent } from 'react'
import { IonContent, IonItemDivider, IonLabel, IonList, IonPage } from '@ionic/react'
import ServiceList from '../serviceList/ServiceList.component'
import { setService } from '../../user/store/user.actions'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { getUserSelector } from '../../user/selectors'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { getServicesStateSelector } from '../selectors'
import { AuthenticationService } from '../../login/services/authentication.service'

const ServiceSelection: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()

  const user = useSelector(getUserSelector)
  const { serviceId, serviceName } = user
  const serviceState = useSelector(getServicesStateSelector)
  const { services } = serviceState

  const logoutOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()

    AuthenticationService.doLogout(user, dispatch)
    history.push(AppRouterConstants.INDEX_ROUTE)
  }

  const nextOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    if (services && !services.length) {
      return
    }
    if (serviceId) {
      // todo: find correct typescript type
      const selectedService: any = document.querySelector('.radio-checked')
      dispatch(setService(serviceId, serviceName !== 'null' ? serviceName : selectedService.dataset.label))
    } else {
      alert('Please select a service.')
    }
  }

  const getNextLabel = () => {
    if (services && !services.length) {
      return ''
    }
    return 'Next'
  }

  const renderServiceList = () => {
    if (services && !services.length) {
      // TODO: add handling of error from server based on invalid app version
      return <h1 data-testid='NoServiceError'>{t('serviceSelection.noServiceError')}</h1>
    }
    return (
      <IonList>
        <IonItemDivider color='light' className='ion-padding'>
          <IonLabel className='grid-item-divider-label' color='medium'>
            {t('serviceSelection.service')}
          </IonLabel>
        </IonItemDivider>

        <ServiceList />
      </IonList>
    )
  }

  return (
    <IonPage>
      <HeaderNav
        prevOnClick={logoutOnClick}
        prevLabel='Logout'
        nextOnClick={nextOnClick}
        nextLabel={getNextLabel()}
        title='Services'
        showOfflineIndicator
      />

      <IonContent fullscreen color='light'>
        {renderServiceList()}
      </IonContent>
    </IonPage>
  )
}

export default ServiceSelection
